import { ignoreIfThrows } from '@wix/cashier-common/dist/src/utils/errorHandling';
import { ICashierSDKConfiguration } from '../cashier-sdk';

export const ignoreCallbackFailures = (
  config: ICashierSDKConfiguration
): ICashierSDKConfiguration => {
  for (const [propName, value] of Object.entries(config)) {
    if (isACallback(config, propName)) {
      config[propName] = ignoreIfThrows(value);
    }
  }

  return config;
};

const isACallback = (
  config: ICashierSDKConfiguration,
  propName: string
): boolean =>
  typeof config[propName] === 'function' &&
  propName.startsWith('on') &&
  propName.charAt(2) === propName.charAt(2).toUpperCase();
